import { SubmissionError } from 'redux-form';
import {clearValues, fetch} from '../../utils/dataAccess';

export function error(error) {
  return { type: 'COMPANY_CREATE_ERROR', error };
}

export function loading(loading) {
  return { type: 'COMPANY_CREATE_LOADING', loading };
}

export function success(created) {
  return { type: 'COMPANY_CREATE_SUCCESS', created };
}

export function create(values) {
  return dispatch => {
    dispatch(loading(true));

    values = clearValues(values, ['country', 'state', 'team']);
    return fetch('companies', { method: 'POST', data: values })
      .then(response => {
        dispatch(loading(false));
        dispatch(success(response.data));
      })
      .catch(e => {
        dispatch(loading(false));

        if (e instanceof SubmissionError) {
          dispatch(error(e.errors._error));
          throw e;
        }

        dispatch(error(e.message));
      });
  };
}

export function reset() {
  return dispatch => {
    dispatch(loading(false));
    dispatch(error(null));
    dispatch(success(null));
  };
}
